import React, { useRef, useState } from 'react';
import { EvidenceCategory } from '../../../services/evidence.service';

export interface EvidenceUploadButtonProps {
  disabled?: boolean;
  onSelect: (category: EvidenceCategory, file: File) => void;
  labels: {
    payment: string;
    signage: string;
    helper: string;
  };
}

const EvidenceUploadButton: React.FC<EvidenceUploadButtonProps> = ({ disabled, onSelect, labels }) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [pendingCategory, setPendingCategory] = useState<EvidenceCategory | null>(null);

  const handlePick = (category: EvidenceCategory) => {
    if (disabled) return;
    setPendingCategory(category);
    fileInputRef.current?.click();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file || !pendingCategory) return;
    onSelect(pendingCategory, file);
    event.target.value = '';
    setPendingCategory(null);
  };

  return (
    <div className="border border-dashed border-gray-300 rounded-lg p-4 bg-white">
      <div className="text-sm text-gray-700 mb-3">{labels.helper}</div>
      <div className="flex flex-wrap gap-3">
        <button
          type="button"
          className="btn-secondary"
          onClick={() => handlePick('PAYMENT')}
          disabled={disabled}
        >
          {labels.payment}
        </button>
        <button
          type="button"
          className="btn-secondary"
          onClick={() => handlePick('SIGNAGE')}
          disabled={disabled}
        >
          {labels.signage}
        </button>
      </div>
      <input
        ref={fileInputRef}
        type="file"
        className="hidden"
        accept="image/jpeg,image/png,application/pdf"
        onChange={handleFileChange}
      />
    </div>
  );
};

export default EvidenceUploadButton;
